import type { OnPageTransitionStartAsync } from "vike/types";
import { nprogress } from "@mantine/nprogress";

export const onPageTransitionStart: OnPageTransitionStartAsync = async () => {
  nprogress.start();
  console.log("%c🚀 Page transition start...", "color: #0ea5e9; font-weight: bold;");
};
